module.exports = __webpack_public_path__ + "img/60000.ecabdb91.jpg";